import { Icon } from "@iconify/react";

export default function AnnouncementBar() {
    return (
        <a
            href="#facturacao-electronica"
            onClick={(e) => {
                e.preventDefault();
                document
                    .querySelector("#facturacao-electronica")
                    ?.scrollIntoView({ behavior: "smooth" });
            }}
            className="fixed top-0 left-0 right-0 z-60 h-10 flex items-center justify-center bg-linear-to-r from-emerald-600 via-emerald-500 to-blue-600 text-white text-center text-sm font-medium px-4 hover:opacity-95 transition-opacity"
        >
            <span className="inline-flex items-center gap-2 truncate">
                <Icon icon="mdi:party-popper" width={16} className="shrink-0" />
                <span className="truncate">
                    <strong>Novidade:</strong> o Logigate já tem{" "}
                    <strong>Facturação Electrónica</strong> certificada pela AGT
                    <span className="hidden sm:inline font-mono text-white/90">
                        {" "}· FE/220/AGT/2026
                    </span>
                </span>
                <span className="hidden sm:inline-flex items-center gap-1 underline underline-offset-2 shrink-0">
                    Saber mais
                    <Icon icon="mdi:arrow-right" width={14} />
                </span>
            </span>
        </a>
    );
}
